// extracted by mini-css-extract-plugin
export var container = "_dg-0";